module.exports = __webpack_public_path__ + "static/media/perso.aaf44142.png";